import * as React from 'react'
import VehiclesTable from '../../list/components/VehiclesTable'
import VehicleBasicActionBar from '../../../shared/actionBars/VehicleBasicActionBar'

import { VehicleFormProvider } from '@/modules/vehicles/context/VehicleFormContext'
import AddVehicleModal from '@/modules/vehicles/modals/vehicleAdd/AddVehicleModal'

interface GroupProps {
  companyId: string
}

const Group: React.FC<GroupProps> = ({ companyId }) => {
  const [isOpenAddVehicle, setIsOpenAddVehicle] = React.useState(false)

  return (
    <>
      <div className="tw-relative tw-bg-content-primary">
        {/* {isTableSelected ? (
          <VehicleSelectedActionBar
            companyId={companyId}
            selectedGroup={selectedGroup}
            resetAll={resetAll}
          />
        ) : (
          )} */}
          <VehicleBasicActionBar  companyId={companyId} />
      </div>
      <div className="tw-z-10 tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden">
        <VehiclesTable companyId={companyId} />
      </div>
      {isOpenAddVehicle && (
        <VehicleFormProvider companyId={companyId} isEdit={false}>
          <AddVehicleModal
            isOpen={isOpenAddVehicle}
            close={() => setIsOpenAddVehicle(false)}
            companyId={companyId}
          />
        </VehicleFormProvider>
      )}
    </>
  )
}

export default Group
